export default "__VITE_ASSET__Dt5nVlZf__"